<app-dialog [title]="data.title" (close)="close()">
    <ng-container dialogContent>
        <div (keydown.enter)="save()" class="settings-name-table-container" [formGroup]="form">
            <ng-container
                dynamic-field
                [field]="{
                    type: 'input',
                    label: appService.language_dictionary.system_field_name,
                    inputType: 'text',
                    name: 'name',
                    autoFocus: true,
                    validations: [
                        {
                            name: 'required',
                            message: appService.language_dictionary.system_field_required,
                        },
                        {
                            name: 'serverError',
                        },
                    ],
                }"
                [group]="form"
            >
            </ng-container>
        </div>
    </ng-container>
    <ng-container dialogActions>
        <fui-button
            (clickEvent)="save()"
            [label]="appService.language_dictionary.system_save"
            [icon]="'content-save'"
            [height]="'mini'"
            [disabled]="form.invalid"
        >
        </fui-button>
        <fui-button
            (clickEvent)="close()"
            [label]="appService.language_dictionary.system_close"
            [color]="'light'"
            [icon]="'close'"
            [height]="'mini'"
        >
        </fui-button>
    </ng-container>
</app-dialog>
